import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { About } from "./components/About";
import { Banner } from "./components/Banner";
import { Footer } from "./components/Footer";
import { NavBar } from "./components/NavBar";
import { Projects } from "./components/Projects";
import { Skills } from "./components/Skills";
import { Timeline } from "./components/Timeline";
import "./i18n/i18n";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <Timeline />
      <About />
      {/*  <Contact /> */}
      <Footer />
    </div>
  );
}

export default App;
